export const FEATURE_FLAG = {
  ACCESS_ARCHIVE: 'accessArchive',
  AGENT_CHAT: 'agentChat',
  ANALYTICS_USER: 'analyticsUser',
  BUSINESS_PARTNER_SETTINGS: 'businessPartnerSettings',
  CLIENT_PORTAL: 'clientPortal',
  CONCRETE_DIARY: 'concreteDiary',
  CREATE_DELIVERY_NOTE: 'createDeliveryNote',
  CREATE_DEMO_DLNS: 'createDemoDlns',
  CUSTOMER_SUBSCRIPTION: 'customerSubscription',
  DATA_SYNC_UI: 'dataSyncUi',
  DEACTIVATED_COMPANY_ACCOUNT: 'deactivatedCompanyAccount',
  DISABLE_INVOICES: 'disableInvoices',
  DLN_LIST_V2: 'dlnListV2',
  ESG_ANALYTICS: 'esgAnalytics',
  ESG_MATERIAL_MATCHER: 'esgMaterialMatcher',
  FLIXBETON: 'flixbeton',
  MANAGE_CALL_OFFS: 'manageCallOffs',
  MANAGE_CONTRACTS: 'manageContracts',
  MANAGE_PRODUCT_PRICES: 'manageProductPrices',
  MANUAL_INVOICE_CHECKING_PIPELINE: 'manualInvoiceCheckingPipeline',
  MODULE_CALL_OFFS: 'moduleCallOffs',
  MODULE_CONTRACTS: 'moduleContracts',
  MODULE_INVOICE_RESTRICTION: 'moduleInvoiceRestriction',
  NEW_SUPPLIERS_KANBAN: 'suppliersKanban',
  NO_PRIVACY_STATEMENT: 'noPrivacyStatement',
  PACKAGE_BASIC_RESTRICTION: 'packageBasicRestriction',
  PRODUCT_ANALYTICS_TOOLS: 'productAnalyticsTools',
  RELEASE_SYNCED_DATA: 'releaseSyncedData',
  SENTRY_GOOGLE_ANALYTICS_DISABLED: 'sentryGoogleAnalyticsDisabled',
  SERVICE_NOTES: 'serviceNotes',
  SUPPLIER_OVERVIEW: 'supplierOverview',
  SUPPLIER_OVERVIEW_REQUEST_SUPPLIER: 'supplierOverviewRequestSupplier',
  USER_IN_DLN_HISTORY: 'userInDlnHistory',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAG)[keyof typeof FEATURE_FLAG];
